export class ListAzureUnassignedNetworkInterfaces200Response {
    'networkInterfaces';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "networkInterfaces",
            "baseName": "networkInterfaces",
            "type": "Array<ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureUnassignedNetworkInterfaces200Response.attributeTypeMap;
    }
    constructor() {
    }
}
